import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

const inputCls = 'bg-white text-[#0A0A0A] border-2 border-[#0A0A0A] rounded-md px-3 py-2 focus:outline-none focus:ring-0 focus:shadow-[4px_4px_0px_0px_rgba(10,10,10,1)] transition-shadow font-medium';
const labelCls = 'text-xs font-bold uppercase tracking-wider text-[#0A0A0A]';

const Field = ({ id, label, list, options, ...props }) => (
  <div>
    <Label htmlFor={id} className={labelCls}>{label}</Label>
    <Input id={id} data-testid={`add-${id}`} list={list} className={inputCls} {...props} />
    {list && <datalist id={list}>{(options || []).map((o) => <option key={o} value={o} />)}</datalist>}
  </div>
);

const empty = (today) => ({ date: today, candidate_name: '', mobile: '', role: '', company_name: '', lineup_by: '', telecaller: '' });

export const AddLineupDialog = ({ open, onOpenChange, today, meta, onSubmit }) => {
  const [form, setForm] = useState(empty(today));
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const ok = await onSubmit(form);
    setSaving(false);
    if (ok) setForm((f) => ({ ...empty(today), date: f.date, company_name: f.company_name, lineup_by: f.lineup_by, telecaller: f.telecaller }));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-2 border-[#0A0A0A] shadow-[6px_6px_0px_0px_rgba(10,10,10,1)] sm:max-w-[520px]" data-testid="add-lineup-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-[#0A0A0A]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Add Lineup</DialogTitle>
          <DialogDescription className="text-xs text-[#404040]">Company, lineup-by and telecaller stay filled so you can add the next candidate quickly.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field id="date" label="Date" type="date" required value={form.date} onChange={set('date')} />
            <Field id="mobile" label="Mobile Number" required placeholder="9876543210" value={form.mobile} onChange={set('mobile')} />
          </div>
          <Field id="candidate_name" label="Candidate Name" required value={form.candidate_name} onChange={set('candidate_name')} />
          <div className="grid grid-cols-2 gap-3">
            <Field id="role" label="Role / Job Category" value={form.role} onChange={set('role')} />
            <Field id="company_name" label="Company Name" required list="dl-companies" options={meta?.companies} value={form.company_name} onChange={set('company_name')} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field id="lineup_by" label="Lineup By" list="dl-lineup-by" options={meta?.lineup_bys} placeholder="Pick or type a name" value={form.lineup_by} onChange={set('lineup_by')} />
            <Field id="telecaller" label="Telecaller (Assigned To)" list="dl-telecallers" options={meta?.telecallers} placeholder="Pick or type a name" value={form.telecaller} onChange={set('telecaller')} />
          </div>
          <Button type="submit" disabled={saving} data-testid="add-lineup-submit" className="w-full bg-[#A3E635] text-[#0A0A0A] border-2 border-[#0A0A0A] rounded-md font-bold py-2 shadow-[2px_2px_0px_0px_rgba(10,10,10,1)] hover:-translate-y-0.5 transition-all">
            {saving ? 'Saving…' : 'Add Candidate'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
